module.exports = __webpack_public_path__ + "img/product-with-variant.36685876.webp";